<template>
    <Card :bordered="false">
        <p slot="title">
            <Icon type="md-pie"/>
            &nbsp;{{$t('runStatus')}}
        </p>
        <div>
            <div ref="echart" class="echart-pie"></div>
        </div>
    </Card>
</template>
<script>
import echarts from 'echarts';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
export default {
    props: {
        item: Object,
        uuid: String
    },
    data() {
        return {
            myChart: {},
            // 图表配置
            options: {
                color: ['#898989', '#009900', '#C6C013', '#EF2917', '#eeeeee', '#fff'], // 主题色
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {d}%'
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    data: [this.$t('stop'), this.$t('run'), this.$t('stby'), this.$t('alarm'), this.$t('off')]
                },
                series: [
                    {
                        name: 'OEE',
                        type: 'pie',
                        radius: ['30%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                formatter: '{b}[{d}%]'
                            }
                        },
                        data: [{ value: this.item.stop, name: this.$t('stop') }, { value: this.item.run, name: this.$t('run') }, { value: this.item.stby, name: this.$t('stby') }, { value: this.item.alarm, name: this.$t('alarm') }, { value: this.item.off, name: this.$t('off') }]
                    }
                ]
            }
        };
    },
    mounted() {
        let dom = this.$refs.echart;
        this.myChart = echarts.init(dom);
        //获取数据
        this.getData();
        let interval = setInterval(() => {
            this.getData();
        }, 30000);
        this.$once('hook:beforeDestroy', () => {
            clearInterval(interval);
        });
    },
    methods: {
        getData() {
            Axios.get(AxiosUrl.device.currentstatus, {
                params: {
                    serial: this.uuid
                }
            }).then(res => {
                let { code, data } = res.data;
                if (code == 200) {
                    let { stop, run, stby, alarm, off } = data;
                    this.options.series[0].data[0].value = stop;
                    this.options.series[0].data[1].value = run;
                    this.options.series[0].data[2].value = stby;
                    this.options.series[0].data[3].value = alarm;
                    this.options.series[0].data[4].value = off;
                    this.myChart.setOption(this.options);
                }
            });
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/group/components/statuschart.vue